import React, { useState } from "react";
import { FormControl, Select, MenuItem, TextField } from "@mui/material";
import { IoIosArrowBack } from "react-icons/io";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { BtnLoader } from "../../components/common/Loader";
import { ApplyLeaveRequest } from "../../apis/apiService";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTheme } from "../../ThemeContext";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";

export const AddLeave = ({ onCancel, onSuccess }) => {
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem("access_token");
  const today = dayjs();
  // Inside your component
  const startDateValue = watch("startDate");
  const endDateValue = watch("endDate");

  // Display options for dropdown (user-friendly)
  const leaveTypes = [
    "Full Day",
    "Half Day",
    "2 Hrs Permission",
    "Compensation Full Day",
    "Compensation Half Day",
    "Work From Home",
  ];

  // Mapping to backend values
  const leaveTypeMap = {
    "Full Day": "FULL DAY",
    "Half Day": "HALF DAY",
    "2 Hrs Permission": "2 hrs",
    "Compensation Full Day": "Compensation Full Day",
    "Compensation Half Day": "Compensation Half Day",
    "Work From Home": "Work from Home",
  };

  const selectedLeaveType = watch("leaveType");

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    const payload = {
      employee_id: login_user?.id || 100,
      leave_type: leaveTypeMap[data.leaveType] || data.leaveType,
      from_date: data.startDate ? data.startDate.format("YYYY-MM-DD") : "",
      to_date: data.endDate ? data.endDate.format("YYYY-MM-DD") : "",
      dev_comments: data.comment || "testing",
    };

    if (
      ["Half Day", "2 Hrs Permission", "Compensation Half Day"].includes(
        data.leaveType
      )
    ) {
      payload.from_time = data.fromTime
        ? dayjs(data.fromTime).format("HH:mm")
        : null;
      payload.to_time = data.toTime ? dayjs(data.toTime).format("HH:mm") : null;
    }

    try {
      const response = await ApplyLeaveRequest(
        "leaverequest/apply",
        payload,
        token
      );
      // console.log("Leave Request Response:", response);

      toast.success(
        response?.message || "Leave request submitted successfully"
      );

      if (onSuccess) {
        onSuccess();
      } else {
        onCancel();
      }
    } catch (error) {
      console.error("Error submitting leave request:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to submit leave request"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack className="me-1" />
            Request Leave
          </div>
        </button>
      </div>

      <div className="bg-white overflow-scroll pb-5 pt-3 px-4">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Leave Type */}
            <div className="row mb-3">
              <div className="col-md-12">
                <label htmlFor="leaveType" className="form-label">
                  Leave Type <span className="text-rgbr-red"> *</span>
                </label>
                <FormControl fullWidth>
                  <Controller
                    name="leaveType"
                    control={control}
                    rules={{ required: "Leave Type is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        displayEmpty
                        inputProps={{ id: "leaveType" }}
                        renderValue={(selected) =>
                          selected ? (
                            selected
                          ) : (
                            <span className="lightText">Select Leave Type</span>
                          )
                        }
                      >
                        {leaveTypes.map((type, index) => (
                          <MenuItem key={index} value={type}>
                            {type}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </FormControl>
                {errors?.leaveType && (
                  <span className="errorMsg">{errors.leaveType.message}</span>
                )}
              </div>
            </div>

            {/* Time Selection */}
            {(selectedLeaveType === "2 Hrs Permission" ||
              selectedLeaveType === "Half Day" ||
              selectedLeaveType === "Compensation Half Day") && (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="fromTime" className="form-label">
                      From Time <span className="text-rgbr-red"> *</span>
                    </label>
                    <Controller
                      name="fromTime"
                      control={control}
                      rules={{ required: "From Time is required" }}
                      render={({ field }) => (
                        <TimePicker
                          {...field}
                          value={field.value ? dayjs(field.value) : null}
                          onChange={(newValue) => field.onChange(newValue)}
                          renderInput={(params) => (
                            <TextField fullWidth {...params} />
                          )}
                        />
                      )}
                    />
                    {errors?.fromTime && (
                      <span className="errorMsg">
                        {errors.fromTime.message}
                      </span>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="toTime" className="form-label">
                      To Time <span className="text-rgbr-red"> *</span>
                    </label>
                    <Controller
                      name="toTime"
                      control={control}
                      rules={{ required: "To Time is required" }}
                      render={({ field }) => (
                        <TimePicker
                          {...field}
                          value={field.value ? dayjs(field.value) : null}
                          onChange={(newValue) => field.onChange(newValue)}
                          renderInput={(params) => (
                            <TextField fullWidth {...params} />
                          )}
                        />
                      )}
                    />
                    {errors?.toTime && (
                      <span className="errorMsg">{errors.toTime.message}</span>
                    )}
                  </div>
                </div>
              </LocalizationProvider>
            )}

            {/* Dates */}
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="startDate" className="form-label">
                  From Date <span className="text-rgbr-red"> *</span>
                </label>
                <div className=" d-flex  flex-column w-100 ">
                  <Controller
                    name="startDate"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        format="DD/MM/YYYY"
                        onChange={(date) => {
                          field.onChange(date);
                          // Auto-map endDate if not manually selected yet
                          if (
                            !endDateValue ||
                            dayjs(endDateValue).isBefore(date)
                          ) {
                            // update endDate in form
                            setValue("endDate", date);
                          }
                        }}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label htmlFor="endDate" className="form-label">
                  To Date <span className="text-rgbr-red"> *</span>
                </label>
                <div className=" d-flex  flex-column w-100 ">
                  <Controller
                    name="endDate"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        format="DD/MM/YYYY"
                        {...field}
                        onChange={(date) => field.onChange(date)}
                        minDate={startDateValue} // ensure endDate cannot be before startDate
                      />
                    )}
                  />
                </div>
              </div>
            </div>

            {/* Comment */}
            <div className="row mb-3">
              <div className="col-md-12">
                <label htmlFor="comment" className="form-label">
                  Comments <span className="text-rgbr-red"> *</span>
                </label>
                <Controller
                  name="comment"
                  rules={{ required: "Comment is required" }}
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} fullWidth multiline rows={3} sx={{
        "& textarea": {
          overflowY: "auto",
        },
        "& textarea::-webkit-scrollbar": {
          cursor: "default !important",
        },
        "& textarea:hover::-webkit-scrollbar": {
          cursor: "default !important",
        },
      }} />
                  )}
                />
                {errors?.comment && (
                  <span className="errorMsg">{errors.comment.message}</span>
                )}
              </div>
            </div>

            {/* Note */}
            <div className="row mb-3">
              <div className="col-md-12">
                <label className="form-label">Note</label>
                <TextField
                  fullWidth
                  multiline
                  rows={8}
                  value="Please ensure that you have informed your reporting lead and obtained their approval before submitting a compensation/leave/permission/work from home request on this portal - if it comes to our attention that you have not obtained approval from your reporting lead then the respective days will be marked as LOP (Loss of Pay)."
                  InputProps={{ disableUnderline: true }}
                  variant="standard"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "red !important",
                    },
                  }}
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="bg-white position-absolute w-100 bottom-0 py-3">
              <div className="d-flex justify-content-left mt-3">
                <button
                  type="submit"
                  className="position-relative add_btn me-3"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <BtnLoader /> : "Add"}
                </button>

                <button
                  type="button"
                  className="cancel_btn"
                  onClick={onCancel}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};
